import type { AlertItem, Locale } from '../types';
import { chrome, formatDataDate } from '../i18n';
import { icon } from './Icon';

const LEVEL_ICON = {
  critical: 'alert-circle',
  warning: 'alert-triangle',
  positive: 'check-circle-2',
} as const;

/** One alert row with level icon, ownership/follow-up metadata, and a trailing tag/link. */
export function AlertCard(a: AlertItem, locale: Locale, trailing?: string): string {
  const c = chrome(locale);
  const isOverdue = Boolean(a.due && a.state !== 'resolved' && a.due < today());
  const meta: string[] = [];
  if (a.owner) meta.push(`<span class="meta-item">${icon('user', 'icon icon-xs')} ${a.owner}</span>`);
  if (a.due) {
    meta.push(
      `<span class="meta-item ${isOverdue ? 'overdue' : ''}" title="${c.dueLabel}">${icon('calendar', 'icon icon-xs')} ${formatDataDate(locale, a.due)}${isOverdue ? ` · ${c.overdue}` : ''}</span>`,
    );
  }
  if (a.state) meta.push(`<span class="state-pill ${a.state}">${c.alertState[a.state]}</span>`);

  return `
    <div class="alert ${a.level}" role="listitem">
      <span class="aicon" aria-hidden="true">${icon(LEVEL_ICON[a.level])}</span>
      <div class="alert-body">
        <div class="t">${a.title}</div>
        <div class="d">${a.detail}</div>
        ${meta.length ? `<div class="alert-meta">${meta.join('')}</div>` : ''}
      </div>
      ${trailing ?? `<div class="tag">${a.tag}</div>`}
    </div>`;
}

function today(): string {
  return new Date().toISOString().slice(0, 10);
}
